module.exports = __webpack_public_path__ + "img/51626529_L.f77ac599.png";